import { render, staticRenderFns } from "./create-ticket.vue?vue&type=template&id=56ed8ab8&"
import script from "./create-ticket.vue?vue&type=script&lang=js&"
export * from "./create-ticket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports